export type Asset = 'USDT' | 'CP' | 'RP';

export type VRank =
  | 'V0' | 'V1' | 'V2' | 'V3' | 'V4' | 'V5' | 'V6' | 'V7' | 'V8' | 'V9';

export type PackageStatus = 'PURCHASED' | 'ACTIVE' | 'COMPLETED';

export type TxType =
  | 'EXTERNAL_DEPOSIT'
  | 'EXTERNAL_WITHDRAW'
  | 'INTERNAL_TRANSFER_OUT'
  | 'INTERNAL_TRANSFER_IN'
  | 'PACKAGE_PURCHASE'
  | 'PACKAGE_ACTIVATE'
  | 'DAILY_RATE'
  | 'BONUS_DYNAMIC'
  | 'BONUS_LEADERSHIP'
  | 'BONUS_SAME_RANK';

export interface PackageTier {
  items: 10 | 50 | 100 | 500 | 1000 | 3000 | 5000;
  dailyRateBps: number;
  profitMultiplierX100: number;
}

export interface PaymentSplit {
  rpPct: number;  // 60-100 in steps of 10
  cpPct: number;  // 0, 10, 20, 30, 40 (complement)
}

/**
 * Valid package payment splits. RP must be ≥ 60% (majority), CP ≤ 40%. Multiples of 10.
 * Default is 100/0 (RP-only — simplest path for users with just deposited RP).
 */
export const PACKAGE_PAYMENT_SPLITS: readonly PaymentSplit[] = [
  { rpPct: 100, cpPct: 0 },
  { rpPct: 90,  cpPct: 10 },
  { rpPct: 80,  cpPct: 20 },
  { rpPct: 70,  cpPct: 30 },
  { rpPct: 60,  cpPct: 40 },
] as const;

export const PACKAGE_TIERS: readonly PackageTier[] = [
  { items: 10,   dailyRateBps: 60, profitMultiplierX100: 250 },
  { items: 50,   dailyRateBps: 60, profitMultiplierX100: 300 },
  { items: 100,  dailyRateBps: 60, profitMultiplierX100: 350 },
  { items: 500,  dailyRateBps: 70, profitMultiplierX100: 400 },
  { items: 1000, dailyRateBps: 80, profitMultiplierX100: 450 },
  { items: 3000, dailyRateBps: 90, profitMultiplierX100: 500 },
  { items: 5000, dailyRateBps: 100, profitMultiplierX100: 550 },
] as const;

export const DYNAMIC_BONUS_BPS_BY_GEN: Readonly<Record<number, number>> = {
  1: 800,
  2: 300,
  3: 200,
  4: 200,
  5: 100,
  6: 100,
  7: 100,
  8: 100,
  9: 100,
  10: 100,
};

export const LEADERSHIP_BONUS_BPS_BY_VRANK: Readonly<Record<VRank, number>> = {
  V0: 0,
  V1: 500,
  V2: 1000,
  V3: 1500,
  V4: 2000,
  V5: 2500,
  V6: 3500,
  V7: 4500,
  V8: 5500,
  V9: 7500,
};

export interface AuthResponse {
  token: string;
  user: {
    id: string;
    email: string;
    username: string;
    referralCode: string;
    vRank: VRank;
  };
}

export interface WalletSummary {
  usdtBalance: string;
  cpBalance: string;
  rpBalance: string;
}
